import { FC, PropsWithChildren } from "react";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PromptLibraryTab } from "@/modules/promptLibrary/promptLibrary.types";
import { List, Star } from "lucide-react";

interface Props {
  onTabClick: (value: PromptLibraryTab) => void;
}

export const PromptLibraryRightDrawerTabs: FC<PropsWithChildren<Props>> = ({ children, onTabClick }) => (
  <Tabs defaultValue={"all"}>
    <TabsList className="my-3 flex justify-start bg-transparent px-2">
      <TabsTrigger
        value={"all"}
        onClick={() => onTabClick("all")}
        className="radius-0 group flex items-center rounded-none border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 shadow-none hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:text-desert-sand-700"
      >
        <List className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
        <span className="px-1">All</span>
      </TabsTrigger>
      <TabsTrigger
        value={"favorite"}
        onClick={() => onTabClick("favourite")}
        className="radius-0 group flex items-center rounded-none border-b-2 border-transparent px-4 py-4 text-sm font-medium text-gray-500 shadow-none hover:border-desert-sand-300 hover:text-gray-700 data-[state=active]:border-desert-sand-700 data-[state=active]:text-desert-sand-700"
      >
        <Star className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
        <span className="px-1">Favourite</span>
      </TabsTrigger>
    </TabsList>
    {children}
  </Tabs>
);
